import { createApp } from 'vue'
import App from './App'
import { router } from './router'
import { store } from './store'
import Api from '@/mixins/Api.js'
import AppInfo from '@/mixins/App-Info.js'
import ApplicationSettings from '@/mixins/Application-Settings.js'
import Children from '@/mixins/Children.js'
import DateFormat from '@/mixins/DateFormat.js'
import Groups from '@/mixins/Groups.js'
import GroupActivityTypes from '@/mixins/Group-Activity-Types.js'
import Utils from '@/mixins/Utils.js'
import Support from '@/mixins/Support.js'
import Translations from '@/mixins/Translation'
import Authorization from '@/mixins/Authorization.js'
import focus from '@/directives/focus'
import * as Sentry from "@sentry/vue";
import { VueMoment } from './plugins/vue-moment';
import { VueLodash } from './plugins/vue-lodash';
import { VueRequest } from './plugins/vue-request';

const app = createApp(App)

app.mixin(Api)
app.mixin(AppInfo)
app.mixin(Children)
app.mixin(DateFormat)
app.mixin(ApplicationSettings)
app.mixin(Groups)
app.mixin(GroupActivityTypes)
app.mixin(Utils)
app.mixin(Support)
app.mixin(Translations)
app.mixin(Authorization)

Sentry.init({
  app,
  dsn: "https://90796977e51f4672b85fb8178372d741@sentry.novict.nl/12",
  // integrations: [
  //   new Sentry.BrowserTracing({
  //     routingInstrumentation: Sentry.vueRouterInstrumentation(router),
  //   }),
  //   new Sentry.Replay(),
  // ],
});

app.directive('focus', focus)

app.use(store)
app.use(router)
app.use(VueLodash)
app.use(VueMoment)
app.use(VueRequest)

try {
  window.app = app;
  app.mount('#app')
} catch (error) {
  console.error('Mounting app failed', error);
}

